export default {
  userRegisteredCard: {
    myWorkTitle: "بطاقاتي المسجلة",
    useBankCardText:
      "يرجى ملاحظة، لإيداعات الريال، استخدم فقط البطاقات البنكية المسجلة. خلاف ذلك، سيتم تعليق معاملتك."
  }
};
